import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchData1 } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import { DataBrew } from 'aws-sdk';


function Ledger1() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [memberid, setMemberId] = useState("");
    const [from, setFromDate] = useState("");
    const [to, setToDate] = useState("");
    const history = useHistory(); // Access the navigation history
    const [memberlist, setMemberOptions] = useState([]);
    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [selectedMembers, setSelectedMembers] = useState({});
    const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
    const [memberList, setMemberList] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const [banklist, setBankOptions] = useState([]);
    const [headlist, setHeadOptions] = useState([]);

    const [selectedhead, setSelectedHead] = useState("");
    const [selectedbank, setSelectedBank] = useState("");
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user

            fetchMember();
            fetchBank();
            fetchAccountHeads();
            logout();
            return;
        }

        // Token is not expired, fetch data


    }, [isAuthenticated, clubId, branchId, token, logout]);

    const dropoptions = [

        { value: 1, label: 'Members' },
        { value: 2, label: 'Bank' },
        { value: 3, label: 'Account Heads' },

    ];
    const handleBankChange = (dropdownOption) => {
        setSelectedBank(dropdownOption);
    };
    const handleHeadChange = (dropdownOption) => {
        setSelectedHead(dropdownOption);
    };
    useEffect(() => {
        fetchMember();
        const currentDate = new Date();
        // Set 'to' as current date
        const to = currentDate.toISOString().split("T")[0]; // Formats the date as YYYY-MM-DD
        setToDate(to);
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

        // Extract day, month, and year
        const day = String(firstDayOfMonth.getDate()).padStart(2, '0'); // Ensure 2-digit day
        const month = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
        const year = firstDayOfMonth.getFullYear();

        // Format as DD-MM-YYYY
        const formattedDate = `${year}-${month}-${day}`;

        setFromDate(formattedDate);


    }, []);
    const fetchBank = async () => {
        try {
            const response = await fetchData('PersonApi', `/${branchId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data
                    .filter(party => party.isBank === true) // Filter for items where isBank is true
                    .map(party => ({
                        value: party.id,
                        label: party.name,
                    }));

                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };
    const fetchMember = async () => {
        try {

            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);

            if (response.responseCode === '1111') {

                const options = response.response_data.map(member => ({
                    value: member.id,
                    label: member.firstName,
                    fullName: `${member.firstName} ${member.lastName}`,
                    phoneNumber: member.phoneNumber,
                    email: member.email,

                }));
                setMemberOptions(options);
                setMemberList(response.response_data);
                fetchBank();
                fetchAccountHeads();
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };
    const fetchAccountHeads = async () => {
        fetchData('AccountHeadApi', `/${clubId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(head => ({
                        value: head.id,
                        label: head.head,

                    }));
                    setHeadOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching AccountHead Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const fetchtableData = async () => {
        try {
            let type = 1; // Use let instead of const
            let memberid1 = memberid; // Declare memberid before using it

            if (selectedOption?.value === 2) {
                type = 5; // Now you can reassign type
                memberid1 = selectedbank.value; // Assign selected bank id  to memberid
            }
            else if (selectedOption?.value === 3) {
                type = 6; // Now you can reassign type
                memberid1 = selectedhead.value; // Assign selected Head id  to memberid
            }
            setData([]);
            const response = await fetchData1('ReportsApi', `/${clubId}/${branchId}/${from}/${to}/${memberid1}/${type}`, token);

            if (response.responseCode === '1111') {
                console.log('Fetched Data:', response);
                setData(response.response_data);
            } else {
                console.warn('Response indicates an issue:', response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
                console.error('Status Code:', error.response.status);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Unexpected Error:', error.message);
            }
        }
    };
    const handleMemberSelectChange = (selectedOption) => {
        setSelectedMembers(selectedOption.value);

    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchtableData();
    }
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setIsModalOpen(true); // Open modal when typing in the search box
    };
    const handleRowClick = (member) => {
        const selectedOption = { value: member.id, label: `${member.firstName} ${member.lastName}` };
        setSelectedMember(selectedOption);
        setSearchTerm(selectedOption.label); // Display the selected name in the search box
        setIsModalOpen(false); // Close modal after selecting a member
        setMemberId(selectedOption.value);
    };
    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };
    const filteredMembers = memberList.filter((member) =>
        `${member.firstName} ${member.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
    );
    let copbal = 0; // Cumulative opening balance for credit
    let dopbal = 0; // Cumulative opening balance for debit
    let bal = 0;    // Running balance
    const handleOptionChange = (option) => {
        setSelectedOption(option);
        fetchBank();
    };

    const computeBalance = (data) => {

        if (data.description !== 'Closing Balance' && data.description !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description !== 'Closing Balance' && data.description !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
        }
        return '';
    };

    const customStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '5px' }}>

            <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}>LEDGER</h6>

            <div className="w-full mb-2 flex" style={{ marginTop: '-9px', justifyContent: 'space-between' }}>

                <div className="w-full mb-2" style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '5px' }}>

                    <div style={{ marginRight: '10px' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                            htmlFor="fromDate"
                        >
                            From Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={from}
                            onChange={(e) => setFromDate(e.target.value)}
                            type="date"
                            placeholder="Select From Date"
                        />
                    </div>
                    <div style={{ marginRight: '10px' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                            htmlFor="toDate"
                        >
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={to}
                            onChange={(e) => setToDate(e.target.value)}
                            type="date"
                            placeholder="Select To Date"
                        />
                    </div>
                    <div className="w-1/4" style={{ marginRight: '10px' }}>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                            style={{ marginRight: '8px' }}
                            htmlFor="ledgerName"
                        >
                            Select Category
                        </label>
                        <Select
                            value={selectedOption}
                            onChange={handleOptionChange}
                            options={dropoptions}
                            placeholder="Select"
                            isSearchable
                            menuPortalTarget={document.body}
                            styles={customStyles}
                        />
                    </div>
                    {selectedOption?.value === 1 && (
                        <div className="col-span-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">Member</label>
                            <input
                                type="text"
                                id="searchMember"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                placeholder="Type to search members"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            />
                            {isModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center z-10">
                                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px', height: '490px', overflowY: 'auto' }}>
                                        <div className="flex justify-end">
                                            <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                        </div>


                                        <table className="mt-4 w-full border border-gray-300" style={{ borderCollapse: 'collapse', marginTop: '-10px' }}>
                                            <thead sx={{ backgroundColor: '#14a3c7' }}>
                                                <tr>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>First Name</th>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Last Name</th>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Phone Number</th>
                                                    <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredMembers.map((member) => (
                                                    <tr
                                                        key={member.id}
                                                        onClick={() => handleRowClick(member)}
                                                        className="cursor-pointer hover:bg-gray-200"
                                                        style={{ borderBottom: '1px solid #ddd' }}
                                                    >
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.firstName}</td>
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.lastName}</td>
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.phoneNumber}</td>
                                                        <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.email}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}




                        </div>
                    )}

                    {selectedOption?.value === 2 && (
                        <div className="w-1/4">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">Bank</label>
                            <div className="flex items-center w-[350px]">
                                <Select
                                    value={selectedbank}
                                    onChange={handleBankChange}
                                    options={banklist}
                                    placeholder="Select Bank"
                                    isSearchable
                                    className="w-full"
                                    menuPortalTarget={document.body}
                                    styles={customStyles}

                                />
                            </div>
                        </div>
                    )}

                    {(selectedOption?.value === 3 &&
                        <div className="w-1/4">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">Account Heads</label>
                            <div className="flex items-center w-[350px]">
                                <Select
                                    value={selectedhead}
                                    onChange={handleHeadChange}
                                    options={headlist}
                                    placeholder="Select Account Head"
                                    isSearchable
                                    className="w-full"
                                    menuPortalTarget={document.body}
                                    styles={customStyles}

                                />
                            </div>
                        </div>
                    )}

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #4D455D,#4D455D)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            marginTop: '2.00%'

                        }}
                        onClick={handleFormSubmit}

                    >
                        <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                        <b style={{ color: 'white' }}>Refresh</b>
                    </Button>
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto', marginTop: '-9px' }}>

                <TableContainer component={Paper}>
                    {/* <Table stickyHeader> */}
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#A8A196', padding: '5px' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#336D82', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'white', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#336D82', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'white', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#336D82', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'white', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#336D82', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'white', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Credit</TableCell>
                                <TableCell sx={{ backgroundColor: '#336D82', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'white', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Debit</TableCell>
                                <TableCell sx={{ backgroundColor: '#336D82', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'white', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((data, index) => (
                                <TableRow key={data.id} sx={data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? { backgroundColor: '#f0f0f0' } : null}>
                                    {data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? (
                                        <TableCell sx={{ fontSize: '14px', padding: '5px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '14px', padding: '5px', cursor: data.billno !== "0" ? 'pointer' : 'default', color: 'blue', textDecoration: 'underline' }}>
                                            {data.billno !== "0" ? (
                                                <Link to={`/PaymentAndReceiptEdit/${data.id}/0/3`} style={{ textDecoration: 'none', color: 'blue' }}>
                                                    {data.billno}
                                                </Link>
                                            ) : (
                                                ''
                                            )}
                                        </TableCell>
                                    )}
                                    {data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? (

                                        <TableCell sx={{ fontSize: '14px', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '14px', padding: '3px' }}>{formatDate(data.date1)}</TableCell>
                                    )}


                                    <TableCell sx={{ fontSize: '14px', padding: '3px', }}>{data.description}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '3px', textAlign: 'right', fontWeight: data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '3px', textAlign: 'right', fontWeight: data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: '14px',
                                            height: '30px',
                                            padding: '5px',
                                            textAlign: 'right',
                                            fontWeight: data.description === 'Opening Balance' || data.description !== 'Closing Balance' || data.description === 'Total' ? 'bolder' : 'normal',
                                        }}
                                    >
                                        {computeBalance(data)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div >
    );
}

export default Ledger1;
